import type { AttributeValueResource } from "@exonn/js-sdk";

export const formatDefinitionAttributes = (
  attributeValues: AttributeValueResource[],
) => {
  return attributeValues
    ?.map((attributeValue) => {
      const attribute = attributeValue.attribute;
      const unit = attribute.unit;
      return (
        attribute.title +
        ": " +
        attributeValue.title +
        (unit ? " " + unit?.title : "")
      );
    })
    .join(", ");
};
